
 export const FIND_A_COURSE = (clearing: any) => {

  const project = process.env.PROJECT?.toLowerCase();
  const slug = clearing
    ? `clearing-course-details-${project}`
    : `course-details-${project}`;

  return `
{
  pageTemplateDynamicPageCollection(
    limit: 1
    where: {
      urlSlug: "${slug}", 
      website: { websiteName: "${process.env.PROJECT}" }
    }
  ) {
    items {
      bottomZoneComponentsCollection(limit: 1) {
        items {
          __typename
          internalName
          cardSectionTitle
          mediaCardsCollection(limit: 2) {
            items {
              ... on Navigation {
                navName
                navUrl
                navDesc
                navTitle
                navCtAlabel
                navCtaTarget
                flagNavItemStyle
              }
              ... on PageLinkPanel {
                internalName
                sectionTitle
                shortDescription
                linkPanelImage {
                  url
                }
                flagComponentStyle
              }
            }
          }
        }
      }
    }
  }
}
`;
};
